import React from 'react'
import { Container, Col,Row, ListGroup, Nav } from 'react-bootstrap'
import './Footer.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import  'react-social-icons/facebook'
import 'react-social-icons/instagram'
import 'react-social-icons/youtube'

import { SocialIcon } from 'react-social-icons'

import play from '../../assets/img/slides/google.jpg'

import app from '../../assets/img/slides/apple.jpg'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <>
    <Container fluid className="footer-bg py-5 mt-5">
      <Container>
        <Row className="g-4">
          <Col xs={12} sm={6} md={6} lg={3}>  
            <div className="footer-column">
              <h5 className='footer-heading'>QUICK LINKS</h5>
              <Nav defaultActiveKey="/home" className="flex-column footer-nav">
                <Nav.Link href="/about" className="footer-link">About Us</Nav.Link>
                <Nav.Link href="/contact" className="footer-link">Contact Us</Nav.Link>
                <Nav.Link href="/privacy" className="footer-link">Privacy Policy</Nav.Link>
                <Nav.Link href="/terms" className="footer-link">Terms of Use</Nav.Link>
              </Nav>
            </div>
          </Col>
          
          <Col xs={12} sm={6} md={6} lg={3}>
            <div className="footer-column">
              <h5 className='footer-heading'>TV SHOWS</h5>
              <Nav defaultActiveKey="/home" className="flex-column footer-nav">
                <Nav.Link href="/shows" className="footer-link">All Shows</Nav.Link>
                <Nav.Link href="/movies" className="footer-link">Movies</Nav.Link>
                <Nav.Link href="/news" className="footer-link">News</Nav.Link>
                <Nav.Link href="/schedule" className="footer-link">Schedule</Nav.Link>
              </Nav>
            </div>
          </Col>
          
          <Col xs={12} sm={6} md={6} lg={3}>
            <div className="footer-column">
              <h5 className='footer-heading'>WATCH</h5>
              <Nav defaultActiveKey="/home" className="flex-column footer-nav">
                <Nav.Link href="/live" className="footer-link">Live TV</Nav.Link>
                <Nav.Link href="/shows" className="footer-link">Shows</Nav.Link>
                <Nav.Link href="/movies" className="footer-link">Movies</Nav.Link>
                <Nav.Link href="/schedule" className="footer-link">TV Schedule</Nav.Link>
              </Nav>
            </div>
          </Col>
          
          <Col xs={12} sm={6} md={6} lg={3}>
            <div className="footer-column">
              <h5 className='footer-heading'>ABOUT US</h5>
              <p className="footer-description">
                YorkeTV is the cord to link Africans and the continent's friends and partners in the UK and Europe to the African continent.
              </p>
              
              <div className="social-icons-wrapper">
                <SocialIcon url="https://www.facebook.com/myChannel7tv/" className="social-icon" />
                <SocialIcon url="https://www.instagram.com/mych7_sky181/" className="social-icon" />
                <SocialIcon url="https://www.youtube.com/channel/UCEoB_eWVj-X9nBrLPvvXYLQ" className="social-icon" />
              </div>

              <hr className="footer-divider"/>
              
              <div className="app-downloads">
                <h6 className="download-heading">Download Our App</h6>
                <div className='app-buttons'>
                  <Link to="https://apps.apple.com/us/app/channel-7/id1543510912" className="app-link">
                    <img src={app} className='appimage' alt="Download on App Store" />
                  </Link>
                  <Link to="https://play.google.com/store/apps/details?id=com.mychannel7&hl=en_US" className="app-link">
                    <img src={play} className='appimage' alt="Get it on Google Play" />
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
    
    <footer className='bg-dark footer-container'>        
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} className="footer-copyright">
            <p>&copy; 2025 YorkeTV. All rights reserved.</p>
          </Col>
          <Col xs={12} md={6} className="footer-credits">
            <p>Developed By <span className="developer-name">Adansonia Partners USA</span></p>
          </Col>
        </Row>
      </Container>
    </footer>
    </>
  )
}

export default Footer